import { ResponseFormat } from '@smartproxy/sp-utils';

// TODO: nuke after migration
export const responseFormatMap: Record<
  ResponseFormat,
  Record<ResponseFormatView, string>
> = {
  json: {
    rich: 'Table',
    text: 'JSON',
  },
  html: {
    rich: 'Live Preview',
    text: 'HTML',
  },
};

export const responseFormatViews = ['text', 'rich'] as const;
export type ResponseFormatView = (typeof responseFormatViews)[number];
